<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table class="page mt-1" id="preview-note">
        <thead id="thead">
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{requestNotePrintModel.noteId}}" class="head col-12 col-lg-12">

                  <!-- Nit -->
                  <p id="nit-empresa-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{requestNotePrintModel.enterpriseNit}}</p>

                  <!-- Nombre Empresa -->
                  <p id="nombre-empresa-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{requestNotePrintModel.enterpriseName}}</p>

                  <!-- Nombre Sucursal -->
                  <p id="nombre-sucursal-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{requestNotePrintModel.branchName}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="direccion-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{requestNotePrintModel.addressBranch}}</p>

                  <!-- Teléfono  -->
                  <label id="t-telefono-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' | formatLabelPipe :
                    elementsLabel}}</label>
                  <p id="telefono-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{requestNotePrintModel.phoneBranch}}</p>

                  <!-- titulo-nota  -->
                  <p id="titulo-nota-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{requestNotePrintModel.titleNote}}</p>

                  <p id="prefijo-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{requestNotePrintModel.consecutive}}</p>

                  <!-- tipo-nota  -->
                  <p id="tipo-nota-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{requestNotePrintModel.typeNote}}</p>

                  <!-- Fecha Nota -->
                  <label id="t-fecha-nota-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-nota' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-nota-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{requestNotePrintModel.dateNote | date: 'dd/MM/yyyy'}}</p>

                  <!-- Cliente  -->
                  <label id="t-cliente-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{requestNotePrintModel.clientNitName1}}</p>

                  <p id="cliente2-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{requestNotePrintModel.clientNitName2 }}</p>

                  <!--Dirección factura Obra -->
                  <label id="t-direccion-factura-obra-{{requestNotePrintModel.noteId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-direccion-factura-obra' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-factura-obra-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">
                    {{requestNotePrintModel.constructionSiteAddress}}</p>

                  <!-- C.Costos  -->
                  <label id="t-centro-costos-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-centro-costos' | formatLabelPipe : elementsLabel}}</label>
                  <p id="centro-costos-{{requestNotePrintModel.noteId}}" *ngIf="requestNotePrintModel.noteId"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{requestNotePrintModel.costCenterCodeName}}
                  </p>

                  <!--Factura Afectada  -->
                  <label id="t-factura-afectada-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-factura-afectada' | formatLabelPipe : elementsLabel}}</label>
                  <p id="factura-afectada-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{requestNotePrintModel.prefixInvoice}}</p>

                  <!-- Fecha Factura  -->
                  <label id="t-fecha-factura-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-factura' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-factura-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{requestNotePrintModel.dateInvoice | date: 'dd/MM/yyyy'}}</p>

                  <!--Valor Factura  -->
                  <label id="t-valor-factura-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-valor-factura' | formatLabelPipe : elementsLabel}}</label>
                  <p id="valor-factura-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{requestNotePrintModel.valueInvoice | currency }}</p>

                  <!--Observación Imprime  -->
                  <label id="t-observacion-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-observacion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="observacion-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{requestNotePrintModel.observationPrint }}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody id="tbody">
          <tr>
            <td>
              <div class="table-container">
                <p-table [value]="requestNotePrintModel.noteDetails" [columns]="columns"
                  [reorderableColumns]="editFormat" (onColReorder)="onColumnReorder()"
                  [rowGroupMode]="formatModel.group ? 'subheader' : undefined"
                  [groupRowsBy]="formatModel.group ? 'conceptInvoicingId' : undefined"
                  [sortField]="formatModel.group ? 'conceptInvoicingId' : undefined" sortMode="single"
                  styleClass="p-datatable-sm" showGridlines>
                  <ng-template #header pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" pReorderableColumn
              [id]="'th-' + idMap[col.field].id + '-' + requestNotePrintModel.noteId" (click)="clickTable($event)"
              [class]=" idMap[col.field].id">
              {{ col.header }}
            </th>
          </tr>
          </ng-template>
          <ng-template #body pTemplate="body" let-rowData let-columns="columns" let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td *ngFor="let col of columns" [id]="'td-' + idMap[col.field].id + '-' + rowData.id"
                (click)="clickTable($event)">
                {{rowData[col.field] | dynamicFormatPipe: idMap[col.field].type}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="groupfooter" let-detail>
            <tr *ngIf="formatModel.group" class="row-group-footer">
              <td [attr.colspan]="columns.length">
                <div class="summary-flex-container"
                  *ngIf="getGroupInfo(requestNotePrintModel.noteId, detail.conceptInvoicingId) as info">

                  <!-- Reteica - Se oculta si la factura es tipo exportación y si no esta activa reteica -->
                  <p *ngIf="reteIca && requestNotePrintModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport"
                    id="foot-group-reteica-{{requestNotePrintModel.noteId}}" (click)="onClick()" class="group-reteica"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    Rte.ICA:{{ info.reteIca | currency }}</p>

                  <!-- Retefuente - Se oculta si la factura es tipo exportación y si no esta activa retefuente-->
                  <p *ngIf="retefuente && requestNotePrintModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport"
                    id="foot-group-retefuente-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                    class="group-retefuente" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    Rte.Fte:{{ info.reteFuente | currency }}</p>

                  <!-- Base IVA - Se oculta si la factura es tipo exportación -->
                  <p *ngIf="requestNotePrintModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport"
                    id="foot-group-baseIva-{{requestNotePrintModel.noteId}}" (click)="onClick()" class="group-baseIva"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{textBaseIva}} {{ info.baseIva | currency }}</p>

                  <!-- Tarifa IVA - Se oculta si la factura es tipo exportación -->
                  <p *ngIf="requestNotePrintModel.bussinessDocumentsDianTypeId != typeDianInvoiceExport"
                    id="foot-group-tarifaIva-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                    class="group-tarifaIva" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{textTarifaIva}}
                    {{ info.rateBaseIva }}%</p>
                </div>
              </td>
            </tr>
          </ng-template>
          </p-table>
          <div id="container-totals">
            <div id="totals">

              <!-- Subtotal -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-subtotal-{{requestNotePrintModel.noteId}}" for="" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()" class="">{{'foot-t-subtotal' | formatLabelPipe :
                  elementsLabel}}</label>
                <p id="foot-subtotal-espacio-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">
                </p>
                <p id="foot-subtotal-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{requestNotePrintModel.subtotalValue |
                  currency}}</p>
              </div>

              <!-- Valor Iva -->
              <div *ngIf="requestNotePrintModel.BussinessDocumentsDianTypeIdInvoice != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-iva-{{requestNotePrintModel.noteId}}" for="" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-iva' | formatLabelPipe :
                  elementsLabel}}</label>
                <p id="foot-valor-iva-espacio-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-valor-iva-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> {{requestNotePrintModel.ivaValue |
                  currency}}</p>
              </div>

              <!-- Total -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-total-{{requestNotePrintModel.noteId}}" for="" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-total' | formatLabelPipe :
                  elementsLabel}}</label>
                <p id="foot-total-espacio-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-total-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> {{requestNotePrintModel.subtotalValue +
                  requestNotePrintModel.ivaValue |
                  currency}}</p>
              </div>

              <!-- ReteIva -->
              <div *ngIf="reteIva && requestNotePrintModel.BussinessDocumentsDianTypeIdInvoice != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-reteIva-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-reteIva' | formatLabelPipe : elementsLabel}}</label>
                <p id="foot-valor-reteIva-espacio-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-valor-reteIva-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{requestNotePrintModel.reteIvaValue |
                  currency}}</p>
              </div>

              <!-- Valor ReteFuente -->
              <div
                *ngIf="retefuente && requestNotePrintModel.BussinessDocumentsDianTypeIdInvoice != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-reteFte-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-reteFte' | formatLabelPipe : elementsLabel}}</label>
                <p id="foot-valor-reteFte-espacio-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-valor-reteFte-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{requestNotePrintModel.reteFuenteValue
                  |
                  currency}}</p>
              </div>

              <!-- ReteIca -->
              <div *ngIf="reteIca && requestNotePrintModel.BussinessDocumentsDianTypeIdInvoice != typeDianInvoiceExport"
                class="row d-flex justify-content-end">
                <label id="foot-t-valor-reteIca-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-reteIca' | formatLabelPipe : elementsLabel}}</label>
                <p id="foot-valor-reteIca-espacio-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"></p>
                <p id="foot-valor-reteIca-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{requestNotePrintModel.reteIcaValue |
                  currency}}</p>
              </div>

              <!-- Valor a Pagar -->
              <div class="row d-flex justify-content-end">
                <label id="foot-t-valor-pagar-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()">{{'foot-t-valor-pagar' | formatLabelPipe : elementsLabel}}
                </label>
                <p id="foot-moneda-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
                  (dragstart)="onDragStart()"> {{(requestNotePrintModel.currencyCode)}}</p>
                <p id="foot-valor-pagar-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"> {{requestNotePrintModel.totalValue |
                  currency}}</p>
              </div>

              <!-- Total en letras -->
              <div class="row pt-1" *ngIf="requestNotePrintModel.currencyId == currencyLocal">
                <p id="foot-totals-in-letters-{{requestNotePrintModel.noteId}}" (click)="onClick()"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  Valor en letras: {{requestNotePrintModel.totalValueInLetters}}</p>
              </div>
            </div>
          </div>
    </div>

    <div id="foot-{{requestNotePrintModel.noteId}}" class="foot container-observations">
      <p id="linea-firma-elabora-{{requestNotePrintModel.noteId}}" class="write-line" (click)="onClick()"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
      <label id="t-firma-elabora-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{'t-firma-elabora' | formatLabelPipe : elementsLabel}}</label>

      <p id="linea-firma-autoriza-{{requestNotePrintModel.noteId}}" class="write-line" (click)="onClick()"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
      <label id="t-firma-autoriza-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{'t-firma-autoriza' | formatLabelPipe : elementsLabel}}</label>

      <p id="linea-firma-revisa-{{requestNotePrintModel.noteId}}" class="write-line" (click)="onClick()"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
      <label id="t-linea-revisa-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{'t-linea-revisa' | formatLabelPipe : elementsLabel}}</label>

      <p id="linea-firma-aprueba-{{requestNotePrintModel.noteId}}" class="write-line" (click)="onClick()"
        (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
      <label id="t-linea-aprueba-{{requestNotePrintModel.noteId}}" (mousedown)="onMouseDown($event)"
        (dragstart)="onDragStart()">{{'t-linea-aprueba' | formatLabelPipe : elementsLabel}}</label>
    </div>
    </td>
    </tr>
    </tbody>
    <tfoot id="tfoot">
      <!-- Primera Fila del Footer -->
      <tr>
        <td colspan="1">
          <div class="d-flex information-print">
            <div class="d-flex justify-content-center align-items-center">
              <!-- 1 -->
              <p class="mt-2 mb-0">
                Nota generada con el Software Cervino de
                Altos Software SAS. Nit.811.022.121-1. www.altos-soft.com
              </p>
            </div>
          </div>
        </td>
      </tr>

      <!-- Segunda Fila del Footer  -->
      <tr>
        <td colspan="1">
          <div id="td-foot-info" class="information-print d-flex flex-wrap">
            <!-- Versión -->
            <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>

            <!-- Fecha Impresión -->
            <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
            <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>

            <!-- Hora Impresión -->
            <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
            <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>

            <!-- Usuario Impresión -->
            <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
            <p id="usuario-impresion" class="pe-4"> {{userAuthenticated}}</p>
          </div>
        </td>
      </tr>
    </tfoot>
    </table>
  </div>
  </div>
</section>